module.exports = __webpack_public_path__ + "static/media/chat.abee796e.png";